import { render, staticRenderFns } from "./QueueView.vue?vue&type=template&id=6c3a9a6d"
import script from "./QueueView.vue?vue&type=script&lang=js"
export * from "./QueueView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports